module.exports = __webpack_public_path__ + "img/operational.5b24ef45.png";